// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label-div[data-v-61ae3202] {\n  color: var(--dark-green-60, #66827f);\n}\n.clear-btn-div[data-v-61ae3202] {\n  color: var(--green);\n  text-decoration: underline;\n}\n.clear-btn-div[data-v-61ae3202]:hover {\n  color: var(--sea);\n  transition: var(--d-ease);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
